export const useCurrentIndex = (value:number) => {
    const currentIndex = ref(value);
    const setCurrentIndex = (value:number) => currentIndex.value = value;

    return {
        currentIndex,
        setCurrentIndex
    }
}